module.exports = __webpack_public_path__ + "img/olsera_logo.8ed6affc.svg";